export default __webpack_public_path__ + "images/ame_dc0203.png";